<template>
  <Wrapper ref="wrapper" page-name="角色管理" v-loading="loading" element-loading-text="数据加载中" element-loading-background="rgba(255, 255, 255, 0.5)">
    <div class="app-container">
      <el-row :gutter="20" style="height:100%">
        <el-col :span="5" style="height:100%">
          <el-card class="left" :body-style="{overflow:'hidden', height: 'calc(100% - 70px)'}" shadow="never">
            <div slot="header" class="header-content flex">
              <span>角色信息</span>
              <el-button
                type="primary"
                class="addRole hand"
                @click="clickAddRole"
              >添加</el-button>
            </div>
            <!-- 新增角色 -->
            <transition name="addText-transform" mode="in-out" appear>
              <div v-show="isShowAddRole" class="addRoleInput">
                <el-input
                  ref="addText"
                  v-model="editRoleText"
                  style="width: 80%"
                />
                <el-tooltip class="item" effect="dark" content="保存" placement="top">
                  <span
                    class="icon iconfont icon-baocun"
                    style="color: #00af84; width: 16px; cursor: pointer;"
                    @click="saveRole"
                  />
                </el-tooltip>
                <el-tooltip class="item" effect="dark" content="取消" placement="top">
                  <i
                    class="icon iconfont icon-shanchu actions-item"
                    style="color: #f33458;cursor: pointer;"
                    @click="cancelAdd"
                  />
                </el-tooltip>
              </div>
            </transition>
            <!-- 角色列表 -->
            <div class="role-table">
              <el-table
                ref="roleTable"
                row-key="roleId"
                :data="roleList"
                tooltip-effect="dark"
                style="width: 100%"
                class="hand"
                :show-header="false"
                :highlight-current-row="highlightCurrentRow"
                @cell-click="clickRole"
                :cell-style="{fontSize: '14px', color: '#464C5E'}"
              >
                <el-table-column prop="roleName" label="角色信息">
                  <template slot-scope="scope">
                    <div style="padding-left: 10px">
                      <el-input
                        v-if="scope.row.isEditor"
                        v-model="editRoleText"
                      />
                      <span v-else>{{
                        scope.row.roleName
                      }}</span>
                    </div>
                  </template>
                </el-table-column>
                <!-- 操作 -->
                <el-table-column label="000" width="130">
                  <template slot-scope="scope">
                    <div class="actions">
                      <el-button
                        type="text"
                        :disabled="isEditRoleing ? isEditing2(scope): isEditing(scope)"
                      >
                        <el-tooltip class="item" effect="dark" :content="icontooltip(scope)" placement="top">
                          <i
                            class="icon iconfont actions-item"
                            :class="
                              isEditRoleing && isEditRoleIndex == scope.$index
                                ? 'icon-baocun'
                                : 'icon-bianji'
                            "
                            @click="clickEdit(scope.$index, scope.row, isEditing(scope))"
                          />
                        </el-tooltip>
                      </el-button>

                      <el-button
                        type="text"
                        :disabled="isEditing(scope)"
                      >
                        <el-tooltip class="item" effect="dark" :content="isEditRoleIndex === scope.$index ?'取消': '删除'" placement="top">
                          <i
                            class="icon iconfont icon-shanchu actions-item"
                            :style=" {color:isEditing(scope) ? '#ccc': '#f33458'}"
                            @click="deleteById(scope.row.roleId, isEditing(scope))"
                          />
                        </el-tooltip>
                      </el-button>

                    </div>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </el-card>
        </el-col>
        <el-col :span="19" style="height:100%">
          <el-card class="right" shadow="never">
            <div slot="header" class="header-content rightmanage">
              管理角色权限
            </div>

            <el-checkbox
              v-model="checkAll"
              :indeterminate="isIndeterminate"
              @change="handleCheckAllChange"
            >全部</el-checkbox>
            <div style="margin: 15px 0" />

            <div
              v-for="menu in menulist"
              :key="menu.menuId"
            >
              <el-checkbox
                v-model="menulistcheckAll[menu.menuId].checkAll"
                class="checkItem-name"
                :indeterminate="menulistcheckAll[menu.menuId].indeterminate"
                @change="(val)=>checkItemAllChange(val, menu.menuId)"
              ><span>{{ menu.name }}</span></el-checkbox>

              <el-checkbox-group
                v-model="menulistcheckAll[menu.menuId].checkMenuIds"
                @change="(val)=>checkedItemChange(val,menu.menuId)"
              >

                <el-checkbox
                  v-for="menuItem in menu.list"
                  :key="menuItem.menuId"
                  class="needHidden"
                  :label="menuItem.menuId"
                >{{ menuItem.name }}</el-checkbox>

              </el-checkbox-group>
            </div>

            <div class="saveBtn">
              <el-button type="primary" @click="save">保存</el-button>
            </div></el-card>
        </el-col>
      </el-row>
    </div>
  </Wrapper>
</template>

<script>
import Wrapper from '@/components/page/Wrapper.vue'
import {getRoleList, update, saveRole, deleteRole, getAllMenuList, getRoleInfo} from '@/api/role'
import { treeDataTranslate } from '@/utils'

export default {
  name: '',
  components: { Wrapper },
  data () {
    return {
      checkAll: false,
      isIndeterminate: false,

      menulistcheckAll: {},
      menulist: [],

      menusListMeusId: [],
      roleList: [],
      isShowAddRole: false,
      isEditRoleing: false,
      isEditRoleIndex: 'null',
      editRoleText: '',
      copyFirstText: '',
      currentRow: null,
      loading: false,
      highlightCurrentRow: true
    }
  },
  computed: {
    icontooltip () {
      return function (scope) {
        const txt = this.isEditRoleing && +this.isEditRoleIndex === +scope.$index ? '保存' : '编辑'
        return txt
      }
    },
    isEditing2 () {
      return function (scope) {
        const currentRow = this.roleList.filter(item => item.roleId === scope.row.roleId)[0]
        return (this.isEditRoleing && this.isEditRoleIndex !== scope.$index) || currentRow.roleName === this.editRoleText
      }
    },
    isEditing () {
      return function (scope) {
        return this.isEditRoleing && this.isEditRoleIndex !== scope.$index
      }
    }
  },
  watch: {
    menulistcheckAll: {
      handler (newVal) {
        const childrenItemLen = Object.keys(newVal).length
        let checkAllLen = 0 // 都选的个数
        let checkNullLen = 0 // 一个都没选的个数
        for (const key in newVal) {
          const item = newVal[key]
          const checkMenuIdsLen = item.checkMenuIds.length
          const childrenMenuIdsLen = item.childrenMenuIds.length
          if (checkMenuIdsLen > 0 && checkMenuIdsLen < childrenMenuIdsLen) {
            item.indeterminate = true
          }
          if (checkMenuIdsLen > 0 && checkMenuIdsLen === childrenMenuIdsLen) {
            item.indeterminate = false
            item.checkAll = true
            ++checkAllLen
          }
          if (checkMenuIdsLen === 0) {
            item.indeterminate = false
            item.checkAll = false
            ++checkNullLen
          }
        }

        if (childrenItemLen === checkAllLen) {
          this.checkAll = true
          this.isIndeterminate = false
        } else {
          this.checkAll = false
          if (childrenItemLen > checkAllLen && checkNullLen < childrenItemLen) {
            this.isIndeterminate = true
          } else {
            this.isIndeterminate = false
          }
        }
      },
      immediate: true,
      deep: true
    }
  },
  mounted () {
    this.getList()
    this.getMenus()
  },
  methods: {
    getList () {
      this.loading = true
      getRoleList().then(({success, data}) => {
        if (success) {
          this.roleList = data.map((item) => ({ ...item, isEditor: false }))
        }
      }).finally(() => {
        this.loading = false
      })
    },
    getMenus () {
      getAllMenuList().then(({success, data}) => {
        if (success) {
          this.menulist = treeDataTranslate(data, 'menuId')
          const obj = {}
          this.menulist.forEach(item => {
            obj[item.menuId] = {}
            obj[item.menuId].checkAll = false
            obj[item.menuId].indeterminate = false
            obj[item.menuId].childrenMenuIds = item.list.map(childItem => childItem.menuId)
            obj[item.menuId].checkMenuIds = []
          })
          this.menulistcheckAll = obj
          this.menusListMeusId = data.map((item) => item.menuId)
        }
      })
    },
    handleCheckAllChange (val) {
      this.isIndeterminate = false
      for (const key in this.menulistcheckAll) {
        const item = this.menulistcheckAll[key]
        item.checkAll = val
        this.checkItemAllChange(val, key)
      }
    },
    checkItemAllChange (val, menuId) {
      const item = this.menulistcheckAll[menuId]
      item.checkMenuIds = val ? item.childrenMenuIds : []
      item.indeterminate = false
    },
    checkedItemChange (val, menuId) {
      const item = this.menulistcheckAll[menuId]
      const count = val.length
      item.checkAll = count === item.childrenMenuIds.length
      item.indeterminate = count > 0 && count < item.childrenMenuIds.length
    },

    deleteById (roleId, isDisabled) {
      if (this.isShowAddRole || isDisabled) return
      if (this.isShowAddRole || this.isEditRoleing) {
        this.cancel()
      } else {
        this.$confirm('确定删除吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
          .then(() => {
            deleteRole([roleId]).then(({success}) => {
              if (success) {
                this.$message({
                  type: 'success',
                  message: '删除成功!'
                })
                this.getList()
                this.clearMenulistcheckAll()
              }
            })
          })
          .catch(() => {
            this.$message({
              type: 'info',
              message: '已取消删除'
            })
          })
      }
    },
    clickAddRole () {
      if (this.isEditRoleing || this.isShowAddRole) return
      this.isShowAddRole = !this.isShowAddRole
      this.editRoleText = ''
      this.$nextTick(() => {
        this.$refs.addText.focus()
      }, 100)
    },
    update (params) {
      update(params).then(({success}) => {
        if (success) {
          this.getList()
          this.$message({
            type: 'success',
            message: '更新成功!'
          })
        }
      })
    },
    clickEdit (index, row, isDisabled) {
      if (this.isShowAddRole || isDisabled) return
      if (this.isEditRoleing) {
        if (this.checekEditRoleText()) {
          return
        }
        const sameRoleNameList = this.roleList.filter(item => item.roleName === this.editRoleText)
        if (sameRoleNameList.length === 1 && row.roleId !== sameRoleNameList[0].roleId || sameRoleNameList.length > 1) {
          this.$message({
            message: '不能有相同角色名称',
            type: 'warning'
          })
          return
        }
      }

      if (!this.isEditRoleing) {
        this.isEditRoleing = !this.isEditRoleing
        this.isEditRoleIndex = index
        this.editRoleText = row.roleName
        this.copyFirstText = row.roleName
        this.currentRow = row
        this.$set(this.roleList[index], 'isEditor', this.isEditRoleing)
      } else {
        this.$nextTick(() => {
          this.editRoleText !== this.copyFirstText && this.editRole()
        })
      }
    },
    getRoles (roleId) {
      this.loading = true
      getRoleInfo(roleId).then(({success, data}) => {
        if (success) {
          this.currentRow = data
          for (const key in this.menulistcheckAll) {
            this.menulistcheckAll[key].checkMenuIds = []
          }
          data.menuIdList.forEach(item => this.searchCheckedMenuId(item))
        }
        this.loading = false
      }).catch(() => {
        this.loading = false
      })
    },
    searchCheckedMenuId (menuId) {
      for (const key in this.menulistcheckAll) {
        const childrenMenuIds = this.menulistcheckAll[key].childrenMenuIds
        if (childrenMenuIds.includes(menuId)) this.menulistcheckAll[key].checkMenuIds.push(menuId)
      }
    },
    clickRole (row, column, event, cell) {
      if (this.isShowAddRole) {
        this.highlightCurrentRow = false
        return
      }
      this.highlightCurrentRow = true
      if (column.property === 'roleName') {
        const roleId = row.roleId
        this.getRoles(roleId)
        if (!this.isShowAddRole && !this.isEditRoleing) this.editRoleText = row.roleName
      }
    },
    editRole () {
      const params = {
        roleId: this.currentRow.roleId,
        roleName: this.editRoleText
      }

      this.$nextTick(async() => {
        await this.update(params)
        this.isEditRoleing = false
        this.copyFirstText = ''
      })
    },
    // 清空左侧选择项
    clearMenulistcheckAll () {
      for (const key in this.menulistcheckAll) {
        this.menulistcheckAll[key].checkAll = false
        this.menulistcheckAll[key].indeterminate = false
        this.menulistcheckAll[key].checkMenuIds = []
      }
    },
    checekEditRoleText () {
      if (this.editRoleText.length > 8) {
        this.$message({
          type: 'warning',
          message: '角色信息字数不能大于8'
        })
        return true
      } else {
        const reg = /^[0-9A-Za-z\u4e00-\u9fa5]+$/
        if (!reg.test(this.editRoleText)) {
          this.$message({
            type: 'warning',
            message: '不能为空且必须是汉字、数字、英文字母'
          })
          return true
        }
      }
      return false
    },
    saveRole () {
      if (this.isEditRoleing) return
      if (this.checekEditRoleText()) {
        return
      }
      if (this.roleList.find(item => item.roleName === this.editRoleText)) {
        this.$message({
          message: '不能有相同角色名称',
          type: 'warning'
        })
        return
      }

      this.loading = true
      let menuIdList = []
      for (const key in this.menulistcheckAll) {
        const item = this.menulistcheckAll[key]
        if (item.checkMenuIds.length) {
          menuIdList = [+key, ...item.checkMenuIds, ...menuIdList]
        }
      }

      const params = {
        menuIdList: [],
        roleName: this.editRoleText
      }

      saveRole(params).then(({success}) => {
        if (success) {
          this.$message({
            type: 'success',
            message: '保存角色信息成功!'
          })
        }
        // this.editRoleText = ''
        this.editRoleText = this.currentRow && this.currentRow.roleName

        this.isEditRoleing = false
        this.isShowAddRole = false
        this.getList()
        this.loading = false
      }).catch(() => {
        this.loading = false
      })
    },
    save () {
      if (this.isEditRoleing || this.isShowAddRole) return
      if (!this.editRoleText) {
        this.$message({
          type: 'warning',
          message: '请选择或填写角色信息!'
        })
        return
      }
      if (this.checekEditRoleText()) {
        return
      }

      let menuIdList = []
      for (const key in this.menulistcheckAll) {
        const item = this.menulistcheckAll[key]
        if (item.checkMenuIds.length) {
          menuIdList = [+key, ...item.checkMenuIds, ...menuIdList]
        }
      }

      const params = {
        menuIdList: this.isShowAddRole ? [] : menuIdList,
        // menuPermissionIds:
        //   (!this.isShowAddRole && this.currentRow && this.currentRow.menuPermissionIds) || undefined,
        remark: (!this.isShowAddRole && this.currentRow && this.currentRow.remark) || undefined,
        roleId: (!this.isShowAddRole && this.currentRow && this.currentRow.roleId) || undefined,
        roleName: this.editRoleText
      }

      update(params).then(({success}) => {
        if (success) {
          this.$message({
            type: 'success',
            message: '保存角色信息成功!'
          })
        }
        // this.editRoleText = ''
        this.editRoleText = this.currentRow && this.currentRow.roleName

        this.isEditRoleing = false
        this.isShowAddRole = false
        this.getList()
      })
    },
    cancel () {
      this.cancelAdd()
      this.cancelEdit()
    },
    cancelEdit () {
      if (this.isEditRoleing) {
        this.isEditRoleing = !this.isEditRoleing
        this.$set(
          this.roleList[this.isEditRoleIndex],
          'isEditor',
          this.isEditRoleing
        )

        this.isEditRoleIndex = 'null'
        this.editRoleText = ''
        this.currentRow = null
      }
    },
    cancelAdd () {
      if (this.isShowAddRole) {
        this.isShowAddRole = !this.isShowAddRole
        this.editRoleText = ''
        this.currentRow = null
      }
    }
  }
}
</script>

<style lang="scss" scoped>
$baseColor: #00af84;
::v-deep .el-input__inner {
  border: 1px solid $baseColor;
}
::v-deep .el-table__body tr.current-row > td.el-table__cell {
  background: #ebf9f5;
  color: #00af84 !important;
}
.app-container {
  width: 100%;
  height: 100%;
  background-color: #eee;
  padding: 0;
  margin: 20px;
  ::v-deep .el-card__header {
    height: 70px;
  }
}
.left {
  height: 100%;
  overflow: auto;
  background-color: #fff;
  .header-content {
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 16px;
  }
  .actions {
    display: flex;
    justify-content: space-around;
    color: $baseColor;
    padding-right: 10px;
    .actions-item {
      transition: transform 0.3s;
      &:hover {
        transform: scale(1.3);
      }
    }
  }
  .addRoleInput {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
}
.right {
  position: relative;
  height: 100%;
  overflow: auto;
  background-color: #fff;
  font-size: 16px;
  .checkItem-name{
    margin-bottom: 20px;
  }
  .saveBtn {
    text-align: center;
    position: absolute;
    bottom: 30px;
    left: 0;
    right:0;
  }

  ::v-deep .el-checkbox-group {
    line-height: 44px;
  }
  ::v-deep .el-card__header {
    height: 70px;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
}

.hand {
  cursor: hand;
  cursor: pointer;
  ::v-deep .el-table__body td.el-table__cell{
    padding: 3px;
  }
}
.role-table {
  border: 1px solid #eee;
  height: 100%;
  border-radius: 5px;
  overflow: auto;
}
div::-webkit-scrollbar {
    width: 1px;
  }
  div::-webkit-scrollbar-thumb {
    border-radius: 10px;
    -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.1);
    opacity: 0.1;
    background: #f3f3f3;
  }
  div::-webkit-scrollbar-track {
    // -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
    border-radius: 0;
    background:  white;
  }

  ::v-deep{
    .needHidden  .el-checkbox__input{
      display: none;
    }
    .needHidden   .el-checkbox__label{
    padding: 5px 30px 5px 16px;
    position: relative;
    background-color: #fff;
    border: 1px solid #ccc;
    border-radius: 1px;
    color: #464C5E;
    opacity: 1;
    cursor: pointer;
    display: inline-block;
    text-align: center;
    overflow: hidden;
    vertical-align: top;
  }
    .needHidden   .el-checkbox__input.is-checked + .el-checkbox__label{
    padding: 5px 28px 5px 16px;
    position: relative;
    background-color: #fff;
    border: 2px solid #00af84;
    border-radius: 1px;
    color: #888;
    opacity: 1;
    cursor: pointer;
    display: inline-block;
    text-align: center;
    overflow: hidden;
    vertical-align: top;
    &::after{
      content: '';
      display: block;
      position: absolute;
      right: 0;
      bottom: 0;
      width: 0;
      height: 0;
      border-top: 12px solid transparent;
      border-bottom: 12px solid #00af84;
      border-left: 10px solid transparent;
      border-right: 10px solid #00af84;
      z-index: 10;
    }
    &::before{
      content: "✓";
      display: inline-block;
      position: absolute;
      right: 1px;
      bottom: -3px;
      color: #fff;
      z-index: 11;
      font-size: 13px;
      font-family: 'MiSans';
    }
  }
  }

</style>
